import { render, staticRenderFns } from "./orderCustomizeVehicle.vue?vue&type=template&id=087d2415&scoped=true"
import script from "./orderCustomizeVehicle.vue?vue&type=script&lang=js"
export * from "./orderCustomizeVehicle.vue?vue&type=script&lang=js"
import style0 from "./orderCustomizeVehicle.vue?vue&type=style&index=0&id=087d2415&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087d2415",
  null
  
)

export default component.exports